<template>
  <!-- 提问详情 -->
  <div id="content" class="container">
    <header>
      <div class="integralBreadcrumb">
        <div
          class="integralBreadcrumb-item"
          @click="routerHandle('onlineTraining')"
        >
          首页
        </div>
        <div class="el-icon-arrow-right jt"></div>
        <div
          class="integralBreadcrumb-item"
          @click="routerHandle('postBarList')"
        >
          全部问答
        </div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item" @click="routerHandle()">
          {{ dataForm.questionTitle }}
        </div>
      </div>
    </header>
    <div class="qustion-left-wrap">
      <div class="main-wrap">
        <main>
          <!-- 问题 -->
          <div class="question-title">
            <ul>
              <li>
                <!-- 头像 -->
                <div class="person">
                  <img :src="dataForm.userAvatarURL || dataForm.img" />
                  <p>{{ dataForm.name }}</p>
                </div>
                <!-- 右侧内容 -->
                <div class="question-con">
                  <div class="question-left">
                    <h3 style="word-wrap: break-word">{{ dataForm.questionTitle }}</h3>
                    <p class="question-latest">
                      <span>{{ dataForm.questionContent }}</span>
                    </p>
                    <div class="question-time">
                      <span class="create-time">{{ dataForm.createTime }}</span>
                      <span
                        v-for="data in dataForm.attributeList"
                        :key="data"
                        :class="
                          dataForm.attributeList[0] != null ? 'label' : ''
                        "
                        >{{ data }}</span
                      >
                    </div>
                  </div>
                  <div class="question-right">
                    <div class="comment-reply-show" title="评论">
                      <img
                        src="../../../../assets/img/comment_03.png"
                        title="评论"
                      />
                      <span>{{ dataForm.replyCount }}</span>
                    </div>
                    <div
                      class="comment-reply-show"
                      title="赞一下"
                      @click="handleZan(dataForm.id, 1)"
                    >
                      <img
                        style="margin-left: 15px"
                        src="../../../../assets/img/zan_03.png"
                        title="赞一下"
                      />
                      <span>{{ dataForm.praiseCount }}</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <!-- 问答列表 -->
          <div class="book-comment">
            <!-- <h6>
              <span>问答列表</span>
            </h6> -->
            <div class="comment-info">
              <!-- 没有最佳答案 -->
              <div class="comment-input" v-if="!dataForm.bestContent">
                <div class="comment-ava">
                  <img :src="headPhoto" />
                </div>
                <div class="comment-right">
                  <div class="comment-author common-name">{{ userName }}</div>
                  <div class="comment-cont">
                    <el-input
                      type="textarea"
                      placeholder="请输入您要回复的文字(最多500字).."
                      maxlength="500"
                      v-model="dataForm.myreply"
                    ></el-input>
                  </div>
                  <div class="comment-me">
                    <el-button
                      style="
                        width: 130px;
                        height: 34px;
                        background: #fff;
                        border: 1px solid #1d65a8;
                        color: #1d65a8;
                      "
                      @click="handleReply('')"
                      >我来回复</el-button
                    >
                  </div>
                </div>
              </div>
              <!-- 有最佳答案 -->
              <div class="comment-input-best" v-else>
                <div class="person">
                  <img :src="dataForm.bestImg ? dataForm.bestImg : img" />
                  <p>{{ dataForm.bestUser }}</p>
                </div>
                <!-- 右侧内容 -->
                <div class="question-con-best">
                  <div class="question-left-best">
                    <h3>{{ dataForm.questionTitle }}</h3>
                    <p class="question-latest">
                      <span>[最佳答案]</span>
                      <span>{{ dataForm.bestcontent }}</span>
                    </p>
                    <div class="question-time">
                      <span class="create-time">{{ dataForm.bestTime }}</span>
                    </div>
                  </div>
                  <div class="question-right-best">
                    <div
                      class="comment-reply-show"
                      title="评论"
                      @click="handleBest"
                    >
                      <img
                        src="../../../../assets/img/comment_03.png"
                        title="评论"
                      />
                      <span>{{ dataForm.bestreplyCount }}</span>
                    </div>
                    <div
                      class="comment-reply-show"
                      title="赞一下"
                      @click="handleZan(dataForm.id, 1)"
                    >
                      <img
                        style="margin-left: 15px"
                        src="../../../../assets/img/zan_03.png"
                        title="赞一下"
                      />
                      <span>{{ dataForm.bestpraiseCount }}</span>
                    </div>
                  </div>
                  <!-- 点击评论展示评论框 -->
                  <div class="comment-show" v-show="commentShow">
                    <el-input
                      type="textarea"
                      placeholder="请输入您要回复的文字"
                      style="margin-bottom: 5px"
                      v-model="dataForm.myCommentReply"
                    ></el-input>
                    <el-button
                      style="
                        float: right;
                        margin-left: 5px;
                        width: 62px;
                        height: 30px;
                        background: #fff;
                        border: 1px solid #1d65a8;
                        color: #1d65a8;
                        font-size: 12px;
                      "
                      @click="handleReply(dataForm.bestId)"
                      >回复</el-button
                    >
                    <el-button
                      style="
                        float: right;
                        width: 62px;
                        height: 30px;
                        background: #fff;
                        border: 1px solid #1d65a8;
                        color: #1d65a8;
                        font-size: 12px;
                        text-align: center;
                      "
                      @click="handleBestCancel()"
                      >取消</el-button
                    >
                  </div>
                  <!-- 评论回复显示评论的回答 -->
                  <div
                    class="comment-all-reply"
                    v-show="commentShow && dataForm.bestList.length"
                  >
                    <ul>
                      <li v-for="item in dataForm.bestList" :key="item.id">
                        <div class="comment-ava new-img">
                          <img :src="item.userAvatarURL" />
                        </div>
                        <div class="com-reply">
                          <p>{{ item.commenterName }} 评论:</p>
                          <p class="com-cont color-666">{{ item.content }}</p>
                          <p class="color-999">
                            发表时间 {{ item.createTime }}
                          </p>
                        </div>
                        <div
                          class="com-good"
                          title="赞一下"
                          @click="handleZan(item.id, 2)"
                        >
                          <img
                            style="float: left; margin-left: 15px"
                            src="../../../../assets/img/zan_03.png"
                          />
                          <span style="float: left; margin-left: 5px">{{
                            item.praiseCount
                          }}</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- 最佳答案图片 -->
                <div class="best-img">
                  <img src="../../../../assets/img/bestAnswer_03.png" />
                </div>
              </div>
            </div>
            <div class="comment-list">
              <ul>
                <li
                  class="comment-list-info"
                  v-for="(data, index) in dataForm.AnswerList"
                  :key="data.id"
                >
                  <div class="comment-ava">
                    <img :src="data.userAvatarURL" />
                  </div>
                  <div class="comment-right">
                    <div class="comment-reply">
                      <div class="common-name">
                        {{ data.commenterName }} 回复：
                      </div>
                      <div class="reply-cont" style="word-wrap: break-word;">{{ data.content }}</div>
                      <div>
                        <div class="time">发表于{{ data.createTime }}</div>
                        <div class="good">
                          <div
                            class="comment-reply-show"
                            @click="handleComment(data.id, index)"
                            title="评论"
                          >
                            <img
                              style="float: left"
                              title="评论"
                              src="../../../../assets/img/comment_03.png"
                            />
                            <span style="float: left; margin-left: 5px">{{
                              data.replyCount
                            }}</span>
                          </div>
                          <div
                            style="float: left; cursor: pointer"
                            title="赞一下"
                            @click="handleZan(data.id, 2)"
                          >
                            <img
                              style="float: left; margin-left: 15px"
                              title="赞一下"
                              src="../../../../assets/img/zan_03.png"
                            />
                            <span style="float: left; margin-left: 5px">{{
                              data.praiseCount
                            }}</span>
                          </div>
                          <!-- delete -->
                          <div
                            style="
                              cursor: pointer
                            "
                            @click="submitDeleteCom(data.id)"
                          >
                            删除
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 点击评论展示评论框 -->
                    <div class="comment-show" v-show="data.showContent">
                      <el-input
                        type="textarea"
                        placeholder="请输入您要回复的文字(最多500字).."
                        maxlength="500"
                        style="margin-bottom: 5px"
                        v-model="dataForm.myCommentReply"
                      ></el-input>
                      <el-button
                        style="
                          float: right;
                          margin-left: 5px;
                          width: 62px;
                          height: 30px;
                          background: #fff;
                          border: 1px solid #1d65a8;
                          color: #1d65a8;
                          font-size: 12px;
                        "
                        @click="handleReply(data.id, index)"
                        >回复</el-button
                      >
                      <el-button
                        style="
                          float: right;
                          width: 62px;
                          height: 30px;
                          background: #fff;
                          border: 1px solid #1d65a8;
                          color: #1d65a8;
                          font-size: 12px;
                          text-align: center;
                        "
                        @click="handleCancel(index)"
                        >取消</el-button
                      >
                    </div>
                    <!-- 评论回复显示评论的回答 -->
                    <div
                      class="comment-all-reply"
                      v-show="data.showContent && data.commentVos.length"
                    >
                      <ul>
                        <li v-for="item in data.commentVos" :key="item.id">
                          <div class="comment-ava new-img">
                            <img :src="item.userAvatarURL" />
                          </div>
                          <div class="com-reply">
                            <p>{{ item.commenterName }} 评论:</p>
                            <p class="com-cont color-666">{{ item.content }}</p>
                            <p class="color-999">
                              发表时间 {{ item.createTime }}
                            </p>
                          </div>
                          <div
                            class="com-good"
                            title="赞一下"
                            @click="handleZan(item.id, 2)"
                          >
                            <img
                              style="float: left; margin-left: 15px"
                              src="../../../../assets/img/zan_03.png"
                            />
                            <span style="float: left; margin-left: 5px">{{
                              item.praiseCount
                            }}</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </main>
      </div>
    </div>
    <questionAsk></questionAsk>
    <!-- 分页 -->
    <div
      class="doclist-pagination"
      v-if="dataForm.AnswerList === [] || dataForm.AnswerList.length !== 0"
    >
      <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
      <div class="doclist-omit">{{ lastOmit }}</div>
      <ul>
        <li
          :class="item === currentPage ? 'pageactive' : ''"
          v-for="(item, index) in pageList"
          :key="index"
          @click="getCommentList(item)"
        >
          {{ item }}
        </li>
      </ul>
      <div class="doclist-omit">{{ nextOmit }}</div>
      <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
      <div class="doclist-pagejump">
        共{{ totalPage }}页，到第
        <input type="text" v-model.number="jumpTargetPage" />页
      </div>
      <div class="doclist-jump" @click="jumpFarPage">确定</div>
    </div>
  </div>
</template>
<script>
import questionAsk from './questionAsk'
export default {
  data () {
    return {
      dataForm: {
        id: '',
        createUser: '',
        name: '',
        questionTitle: '',
        questionContent: '',
        createTime: '',
        replyCount: '',
        praiseCount: '',
        img: require('@/assets/img/avatar-boy.gif'),
        userAvatarURL: '', // 头像地址
        attributeList: [], // 标签列表
        AnswerList: [], // 回答
        myreply: '',
        myCommentReply: '',
        commentId: '',
        bestContent: '',
        bestImg: '',
        bestUser: '',
        bestcontent: '',
        bestTime: '',
        bestreplyCount: '',
        bestpraiseCount: '',
        bestList: [],
        bestId: ''
      },
      comment: false,
      commentShow: false,
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      totalData: 0,
      dataListLoading: false,
      currentIndex: 0,
      which: '',
      SubId: '',
      currentPage: 1,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1,
      headPhoto: this.$store.state.user.headPhoto,
      userName: this.$store.state.user.name
    }
  },
  mounted () {
    this.getDataList()
    this.getCommentList()
  },
  components: {
    questionAsk
  },
  watch: {
    $route (to, from) {
      if (this.$route.query.id) {
        this.dataForm.myreply = ''
        this.dataForm.myCommentReply = ''
        this.getDataList()
        this.getCommentList()
        this.dataForm.bestContent = ''
      }
    }
  },
  methods: {
    routerHandle (routerName) {
      if (routerName === 'onlineTraining') {
        this.$router.push({ name: 'onlineTraining' })
      } else if (routerName === 'postBarList') {
        this.$router.push({ name: 'postBarList' })
      }
    },
    // 最佳答案
    handleBest () {
      this.commentShow = !this.commentShow
    },
    // 获取详情
    getDataList () {
      this.$http
        .post(
          `/front/train/trainQuestionAnswer/listQuestionsWithAnswersAtFrontGround/${this.$route.query.id}`,
          {}
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataList = res.data
            this.dataForm.id = res.data.id
            this.dataForm.questionTitle = res.data.questionTitle
            this.dataForm.questionContent = res.data.questionContent
            this.dataForm.createTime = res.data.createTime
            this.dataForm.name = res.data.name
            this.dataForm.attributeList = res.data.attributeList
            this.dataForm.userAvatarURL = res.data.userAvatarURL
            this.dataForm.replyCount = res.data.replyCount
            this.dataForm.praiseCount = res.data.praiseCount
            this.dataForm.createUser = res.data.createUser
            if (res.data.bestComment) {
              this.dataForm.bestContent = true
              this.dataForm.bestImg = res.data.bestComment.userAvatarURL
              this.dataForm.bestUser = res.data.bestComment.commenterName
              this.dataForm.bestcontent = res.data.bestComment.content
              this.dataForm.bestTime = res.data.bestComment.createTime
              this.dataForm.bestreplyCount = res.data.bestComment.replyCount
              this.dataForm.bestpraiseCount = res.data.bestComment.praiseCount
              this.dataForm.bestList = res.data.bestComment.commentVos
              this.dataForm.bestId = res.data.bestComment.id
            }
          }
        })
    },
    // 获取评论列表
    getCommentList (page = this.currentPage) {
      this.$http
        .post(`/front/train/trainQuestionsComment/listCommentAtDetailPage`, {
          page: page,
          limit: this.pageSize,
          id: this.$route.query.id
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            if (res.data) {
              this.dataForm.AnswerList = res.data.data
              this.dataForm.AnswerList.forEach((item) => {
                item.showContent = false
              })
              // 分页
              this.totalPage = Math.ceil(res.data.count / 10)
              this.changePageTo(page)
              this.totalData = res.data.count
              this.$nextTick(() => {
                this.$set(this.dataForm.AnswerList, this.which, {
                  ...this.dataForm.AnswerList[this.which],
                  showContent: true
                })
              })
            }
          }
        })
      this.jumpTargetPage = 1
    },
    // 我来回复
    handleReply (id, index) {
      if (!this.$store.state.user.userId) {
        this.$message('游客请先登录')
        return
      }
      if (id === '' && this.dataForm.myreply === '') {
        this.$message('回复内容不能为空')
        return
      }
      if (id !== '' && this.dataForm.myCommentReply === '') {
        this.$message('回复内容不能为空')
        return
      }
      this.which = index
      this.$http
        .post(`/front/train/trainQuestionsComment/save`, {
          questionId: this.$route.query.id + '',
          content:
            id === '' ? this.dataForm.myreply : this.dataForm.myCommentReply,
          commentId: id
        })
        .then(({ data: res }) => {
          if (res && res.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.butLoading = false
                this.dataForm.myreply = ''
                this.dataForm.myCommentReply = ''
                this.getDataList()
                this.getCommentList()
              }
            })
          } else {
            this.$message.error(res.msg || '提问失败')
            this.butLoading = false
          }
        })
    },
    // 分页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.getCommentList(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.getCommentList(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    changePageTo (page) {
      window.scrollTo(0, 0)
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (
            this.jumpTargetPage > 2 &&
            this.jumpTargetPage < this.totalPage - 4
          ) {
            var newPageList3 = []
            for (
              let index = this.jumpTargetPage - 2;
              index < this.jumpTargetPage + 3;
              index++
            ) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [
              this.totalPage - 4,
              this.totalPage - 3,
              this.totalPage - 2,
              this.totalPage - 1,
              this.totalPage
            ]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.getDataList()
        this.getCommentList()
        window.scrollTo(0, 0)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
      this.getCommentList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
      this.getCommentList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 展示回复框
    handleComment (id, index) {
      var show = !this.dataForm.AnswerList[index].showContent
      this.$set(this.dataForm.AnswerList, index, {
        ...this.dataForm.AnswerList[index],
        showContent: show
      })
    },
    // 取消
    handleCancel (index) {
      this.$set(this.dataForm.AnswerList, index, {
        ...this.dataForm.AnswerList[index],
        showContent: false
      })
    },
    // 最佳答案取消
    handleBestCancel () {
      this.commentShow = false
    },
    // 点赞
    handleZan (id, type) {
      this.$http
        .post(`/front/train/trainPraise/save`, {
          targetId: id,
          type: type
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message({
              message: '点赞成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
                this.getCommentList()
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    // 删除贴吧评论
    submitDeleteCom (id) {
      this.$http.post(`/help/train/trainQuestionsComment/delete/${id}`).then(({ data: res }) => {
        if (res && res.code === 0) {
          this.$message.success('操作成功')
        }
      })
      this.$router.go(0)
    }
  }
}
</script>
<style scoped lang="scss">
.page {
  float: left;
}
main {
  min-height: 600px;
}
.main-wrap {
  width: 840px;
  min-height: 700px;
  background: #fff;
  margin-bottom: 10px;
}
.qustion-left-wrap {
  width: 840px;
  min-height: 880px;
  float: left;
}
.question-title {
  width: 840px;
  float: left;
  height: 182px;
  padding: 10px 0;
  // border-bottom:1px solid #ccc;
  background: #fff;
  margin-bottom: 10px;
}
.person {
  float: left;
  width: 100px;
  height: 85px;
  text-align: center;
  margin-right: 30px;
  margin-top: 20px;
}
.person img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-bottom: 10px;
}
.person p {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.question-con {
  min-height: 80px;
  float: left;
  width: 700px;
}
// 最佳答案
.question-con-best {
  min-height: 80px;
  float: left;
  width: 670px;
}
.question-left {
  width: 570px;
  float: left;
}
.question-left-best {
  width: 470px;
  float: left;
  margin-bottom: 10px;
}
.question-left-best h3 {
  // height: 30px;
  height: auto;
  line-height: 30px;
  font-weight: 600;
  margin-top: 20px;
  color: #333;
  margin-bottom: 15px;
}
.question-left h3 {
  height: auto;
  font-weight: 600;
  margin-top: 20px;
  color: #333;
  margin-bottom: 15px;
}
// 最佳答案
.question-right-best {
  float: right;
  width: 120px;
  height: 80px;
  text-align: center;
  padding-top: 110px;
  padding-left: 12px;
}
.question-right-best img {
  width: 15px;
  height: 15px;
}
// 回答数浏览数
.question-right {
  float: right;
  width: 120px;
  height: 162px;
  text-align: center;
  padding-top: 126px;
}
.question-right img {
  width: 15px;
  height: 15px;
}
.question-latest {
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 15px;
}
// 问答列表
.book-comment {
  min-height: 270px;
  background: #fff;
  float: left;
  padding: 0 20px;
}
.book-comment h6 {
  font-weight: normal;
  margin-bottom: 10px;
}
.book-comment h6 span {
  border-left: 5px solid #333;
  color: #333;
  font-size: 16px;
  display: inline-block;
  line-height: 18px;
  padding-left: 10px;
}
.comment-info {
  margin-top: 20px;
}
.comment-input {
  height: 170px;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #ccc;
}
// 最佳答案
.comment-input-best {
  height: auto;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #ccc;
  margin-top: -20px;
  background: #fffaed;
  position: relative;
}
.comment-input-best::after {
  content: "";
  clear: both;
  display: block;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}
.best-img {
  width: 135px;
  height: 48px;
  position: absolute;
  top: 0;
  right: 0;
}
.best-img img {
  width: 135px;
  height: 48px;
}
.comment-ava {
  width: 60px;
  height: 65px;
  float: left;
}
.comment-ava img {
  width: 50px;
  width: 50px;
  border-radius: 50%;
}
.comment-right {
  float: left;
  margin-left: 10px;
  width: 730px;
  min-height: 150px;
  background: #fff;
}
.person {
  margin-bottom: 20px;
}
.comment-me {
  float: right;
  margin-top: 20px;
}
.comment-list-info {
  height: auto;
  width: 100%;
  border-bottom: 1px solid #ccc;
  padding-top: 20px;
}
.comment-list ul ::after {
  content: "";
  clear: both;
  display: block;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}
.time {
  float: left;
  color: #999;
}
.good {
  float: right;
  width: 180px;
  height: 30px;
  text-align: center;
  padding-left: 50px;
}
.comment-author {
  float: left;
  margin-bottom: 20px;
}
.common-name {
  color: #333;
}
.reply-cont {
  margin: 10px 0;
  color: #666;
}
.good img {
  width: 15px;
  height: 15px;
}
.label {
  display: inline-block;
  min-width: 30px;
  height: 25px;
  line-height: 25px;
  background: #f5f5f5;
  margin-right: 10px;
  color: #999;
  padding: 0 5px;
}
.create-time {
  margin-right: 10px;
}
.comment-show {
  height: 100px;
  width: 100%;
  border-top: 1px solid #ccc;
  padding-top: 10px;
  margin-bottom: 10px;
}

.comment-reply {
  width: 100%;
  height: auto;
}
.comment-all-reply {
  width: 730px;
  height: auto;
  float: right;
  padding-left: 20px;
  margin-top: 10px;
}
.comment-all-reply ul li {
  padding-top: 20px;
}
div.new-img img {
  width: 40px;
  height: 40px;
}
.com-reply {
  float: left;
  width: 550px;
  // height:100px;
  border-bottom: 1px solid #ccc;
}
.com-good {
  width: 100px;
  // height:100px;
  float: right;
  border-bottom: 1px solid #ccc;
  padding-top: 57px;
  cursor: pointer;
}
.com-good img {
  width: 15px;
  height: 15px;
}
.color-666 {
  color: #666;
}
.color-999 {
  color: #999;
}
.com-cont {
  margin-top: 5px;
  margin-bottom: 10px;
}
.comment-all-reply ul li:last-child .com-reply {
  border: 0px;
}
.comment-all-reply ul li:last-child .com-good {
  border: 0px;
}
.comment-reply-show {
  float: left;
  cursor: pointer;
}
.doclist-pagination {
  float: left;
  margin-bottom: 10px;
}
</style>
